import React from 'react';
import MaterialIcon from '../MaterialIcon';

const Testimonials = () => {
  return (
    <section className="relative py-16 md:py-24 bg-white overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-[#F1F600]/5 rounded-full mix-blend-multiply filter blur-2xl"></div>
        <div className="absolute bottom-1/4 left-0 w-96 h-96 bg-[#FF4D4D]/5 rounded-full mix-blend-multiply filter blur-2xl"></div>
      </div>

      <div className="relative container-wide">
        <div className="text-center mb-24">
          <span className="inline-block mb-4">
            <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#F1F600]/20 p-3">
              <MaterialIcon icon="format_quote" className="text-[#2C3E50]" />
            </span>
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-[#2C3E50]">
            客户心声
          </h2>
          <p className="text-[#2C3E50]/80 max-w-2xl mx-auto text-lg font-medium">
            来自各行业领袖的真实反馈，见证专业教练服务带来的改变
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* 第一个评价 */}
          <div className="group relative p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="flex items-start mb-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#F1F600]/20 to-[#FFB302]/20 flex items-center justify-center">
                  <MaterialIcon icon="person" className="text-3xl text-[#F1F600]" />
                </div>
              </div>
              <div className="ml-4">
                <div className="flex items-center">
                  <h4 className="text-xl font-bold text-[#2C3E50]">陈总</h4>
                  <span className="ml-2 text-[#F1F600]">
                    <MaterialIcon icon="verified" className="text-sm" />
                  </span>
                </div>
                <p className="text-[#2C3E50]/80 font-medium">科技创业公司创始人</p>
              </div>
            </div>
            <div className="relative">
              <span className="absolute -top-6 -left-2 text-7xl text-[#F1F600]/20 opacity-60 font-serif">"</span>
              <p className="text-[#2C3E50]/90 leading-relaxed mb-6 relative z-10 text-lg">
                在一对一教练的帮助下，我学会了如何更好地授权和培养团队。通过每周的教练对话，我不仅提升了领导力，还找到了工作与生活的平衡点。现在的我，更懂得倾听团队的声音，也更清楚公司的发展方向。
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-1">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <MaterialIcon icon="star" className="text-[#F1F600] transform group-hover:scale-110 transition-transform duration-300 delay-100" key={star} />
                  ))}
                </div>
                <div className="flex items-center text-sm text-[#2C3E50]/60">
                  <MaterialIcon icon="schedule" className="text-[#2C3E50]/40 mr-1 text-base" />
                  3个月前
                </div>
              </div>
            </div>
          </div>

          {/* 第二个评价 */}
          <div className="group relative p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="flex items-start mb-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#FF4D4D]/20 to-[#FFB302]/20 flex items-center justify-center">
                  <MaterialIcon icon="person" className="text-3xl text-[#FF4D4D]" />
                </div>
              </div>
              <div className="ml-4">
                <div className="flex items-center">
                  <h4 className="text-xl font-bold text-[#2C3E50]">王经理</h4>
                  <span className="ml-2 text-[#FF4D4D]">
                    <MaterialIcon icon="verified" className="text-sm" />
                  </span>
                </div>
                <p className="text-[#2C3E50]/80 font-medium">跨国企业人力资源总监</p>
              </div>
            </div>
            <div className="relative">
              <span className="absolute -top-6 -left-2 text-7xl text-[#FF4D4D]/20 opacity-60 font-serif">"</span>
              <p className="text-[#2C3E50]/90 leading-relaxed mb-6 relative z-10 text-lg">
                企业内训项目让我们的管理层有了质的提升。通过为期6个月的系统培训，我们的中高层管理者掌握了教练式领导力技能，团队沟通更顺畅，员工敬业度提升了30%，这些都是实实在在的改变。
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-1">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <MaterialIcon icon="star" className="text-[#FF4D4D] transform group-hover:scale-110 transition-transform duration-300 delay-100" key={star} />
                  ))}
                </div>
                <div className="flex items-center text-sm text-[#2C3E50]/60">
                  <MaterialIcon icon="schedule" className="text-[#2C3E50]/40 mr-1 text-base" />
                  1个月前
                </div>
              </div>
            </div>
          </div>

          {/* 第三个评价 */}
          <div className="group relative p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="flex items-start mb-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#FFB302]/20 to-[#F1F600]/20 flex items-center justify-center">
                  <MaterialIcon icon="person" className="text-3xl text-[#FFB302]" />
                </div>
              </div>
              <div className="ml-4">
                <div className="flex items-center">
                  <h4 className="text-xl font-bold text-[#2C3E50]">刘总</h4>
                  <span className="ml-2 text-[#FFB302]">
                    <MaterialIcon icon="verified" className="text-sm" />
                  </span>
                </div>
                <p className="text-[#2C3E50]/80 font-medium">制造业企业总经理</p>
              </div>
            </div>
            <div className="relative">
              <span className="absolute -top-6 -left-2 text-7xl text-[#FFB302]/20 opacity-60 font-serif">"</span>
              <p className="text-[#2C3E50]/90 leading-relaxed mb-6 relative z-10 text-lg">
                团队教练项目帮助我们打破了部门墙，建立起高效协作的机制。原本需要两周才能完成的跨部门项目，现在一周就能搞定。最重要的是，团队成员的主动性和创造力都被激发出来了。
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-1">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <MaterialIcon icon="star" className="text-[#FFB302] transform group-hover:scale-110 transition-transform duration-300 delay-100" key={star} />
                  ))}
                </div>
                <div className="flex items-center text-sm text-[#2C3E50]/60">
                  <MaterialIcon icon="schedule" className="text-[#2C3E50]/40 mr-1 text-base" />
                  2个月前
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 
